module.exports = __webpack_public_path__ + "assets/img/invoice.6165a6b7.png";